import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { GetStartedButton } from './GetStartedButton';
import getAppUrls from '../../constants/appUrls';
import { Text } from 'foundations-components/components/Text';
import { Section } from 'foundations-components/transitional/components/Section';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { KB_URL_MANAGE_SEATS } from '../../constants/externalUrls';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Box } from 'foundations-components/transitional/components/Box';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Container = ({
  isDefaultUse,
  'data-test-id': dataTestId,
  children
}) => {
  if (isDefaultUse) {
    return /*#__PURE__*/_jsx(Flex, {
      borderWidth: "100",
      borderStyle: "solid",
      borderColor: "border-core-default",
      maxInlineSize: "800px",
      padding: "1000",
      justifyContent: "space-between",
      "data-test-id": dataTestId,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    paddingInline: "600",
    paddingBlock: "500",
    justifyContent: "space-between",
    alignItems: "start",
    "data-test-id": dataTestId,
    children: children
  });
};
export default function UnlockCallingItem({
  use = 'default',
  blockingType,
  showIntegrationsLink = true,
  onTrack,
  'data-test-id': dataTestId
}) {
  const {
    integrationsUrl,
    paidUsersManagementUrl
  } = getAppUrls();
  const isPaidSeatBlocking = blockingType === 'paid-seat-blocking';
  const isDefaultUse = use === 'default';
  return /*#__PURE__*/_jsxs(Container, {
    isDefaultUse: isDefaultUse,
    "data-test-id": dataTestId,
    children: [isPaidSeatBlocking && /*#__PURE__*/_jsx(Illustration, {
      name: "calling",
      marginInlineEnd: isDefaultUse ? '1000' : '600',
      width: isDefaultUse ? '120px' : '80px'
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-200",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `calling-orchestration-shared-library.unlock-calling.${blockingType}.title`
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `calling-orchestration-shared-library.unlock-calling.${blockingType}.description`
        })
      }), !isPaidSeatBlocking ? /*#__PURE__*/_jsx(GetStartedButton, {
        onTrack: onTrack
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
          children: [/*#__PURE__*/_jsx(Button, {
            "data-test-id": "manage-seats-button",
            use: "primary",
            href: paidUsersManagementUrl,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "calling-orchestration-shared-library.unlock-calling.paid-seat-blocking.manage-seats-button-text"
            })
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "learn-more",
            use: "secondary",
            external: true,
            href: KB_URL_MANAGE_SEATS,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "calling-orchestration-shared-library.unlock-calling.learn-more-button-text"
            })
          })]
        }), showIntegrationsLink && /*#__PURE__*/_jsx(View, {
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "calling-orchestration-shared-library.unlock-calling.alternative-link_jsx",
              elements: {
                UILink: Link
              },
              options: {
                href: integrationsUrl
              }
            })
          })
        })]
      })]
    }), !isPaidSeatBlocking && /*#__PURE__*/_jsx(Illustration, {
      name: "calling-set-up",
      height: isDefaultUse ? '140px' : '100px',
      marginInlineStart: isDefaultUse ? '1200' : '600'
    })]
  });
}